module.exports = __webpack_public_path__ + "img/apple_pay.png";